import React, { useEffect } from "react";
import { Link } from "react-router-dom";

/**
 * @param {Object} props
 * @param {string} props.title - Page <title> and H1
 * @param {string} props.description - Meta description & hero subtitle
 * @param {string} [props.eyebrow]
 * @param {{ to?: string, label: string }[]} props.breadcrumb - Last item may omit `to` (current page)
 * @param {boolean} [props.wide] - Wider article column (e.g. guide index cards)
 * @param {React.ReactNode} props.children
 */
const DEFAULT_DESCRIPTION =
  "Discover GitHub developers and public repositories in one app. Filter by language, skills, and activity. Profile and repo cards from the GitHub API.";

const GuideLayout = ({ title, description, eyebrow = "Guide", breadcrumb, wide, children }) => {
  useEffect(() => {
    document.title = `${title} | GitHub Finder`;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) {
      meta.setAttribute("content", description);
    }
    return () => {
      document.title = "GitHub Finder | Search GitHub Developers & Repositories";
      const m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", DEFAULT_DESCRIPTION);
    };
  }, [title, description]);

  return (
    <div className="gf-page gf-guide-page">
      <div className="gf-hero-band gf-hero-band--guide">
        <div className="gf-container">
          <div className="gf-hero gf-hero--tool gf-guide-hero">
            {breadcrumb?.length > 0 && (
              <nav className="gf-guide-breadcrumb" aria-label="Breadcrumb">
                {breadcrumb.map((item, i) => (
                  <React.Fragment key={`${item.label}-${i}`}>
                    {i > 0 && (
                      <span className="gf-guide-breadcrumb__sep" aria-hidden="true">
                        /
                      </span>
                    )}
                    {item.to ? (
                      <Link to={item.to}>{item.label}</Link>
                    ) : (
                      <span className="gf-guide-breadcrumb__current">{item.label}</span>
                    )}
                  </React.Fragment>
                ))}
              </nav>
            )}
            <p className="gf-guide-hero__eyebrow">{eyebrow}</p>
            <h1 className="gf-hero__title">{title}</h1>
            <p className="gf-hero__sub gf-guide-hero__sub">{description}</p>
          </div>
        </div>
      </div>

      <div
        className={`gf-container gf-guide-body${wide ? " gf-guide-body--wide" : ""}`}
      >
        {children}
      </div>
    </div>
  );
};

export default GuideLayout;
